module.exports = __webpack_public_path__ + "img/西瓜4.eedfcae6.png";